import React from 'react';
import useStyles from './styles';
import clsx from 'clsx';
import Avatar from '@material-ui/core/Avatar';

const FoodMeter = (props) => {
    const { foodCount = 0, iconUrl = './assets/images/components/island/particle/drumstick.png' } = props;
    const classes = useStyles(props)

    return (
        <div className={classes.food_root}>
            <Avatar className={clsx(classes.avatar, classes.gray, classes.borderColor_darkorange)} src={iconUrl}></Avatar>
            <div className={classes.feedCountText}>{`x ${foodCount}`}</div>
        </div >
    )
}

export default FoodMeter;